module.exports = __webpack_public_path__ + "static/img/uidesignmobile.1c17d67.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/TiiVii/uidesignmobile.png
// module id = GO6h
// module chunks = 0